<template>
  <div id="contenedor-registrar-nueva-fianza">
    <v-form v-model="formularioValido" ref="registrarNuevaFianza">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva fianza
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-select
              cols="12"
              v-model="fianza.tipo"
              label="Tipo"
              :items="tipos"
              item-value="id"
              item-text="nombre"
              :rules="[mixReglas.requerido]">
            </custom-select>
            <!-- <v-col cols="12">
              <v-select
                v-model="fianza.tipo"
                label="Tipo"
                outlined
                :items="tipos"
                item-value="id"
                item-text="nombre"
                hide-details
                :rules="[mixReglas.requerido]"
              >
              </v-select>
            </v-col> -->
            <text-field
              v-model="fianza.numero"
              label="Número"
              cols="6"
              :rules="[mixReglas.requerido]"
            >
            </text-field>
            <date-picker
              v-model="fianza.fecha"
              label="Fecha"
              cols="6"
              :rules="[mixReglas.requerido]"
            >
            </date-picker>
            <text-field v-model="fianza.nombreAfianzadora" label="Nombre Afianzadora" cols="6">
            </text-field>
            <text-field
              v-model.number="fianza.monto"
              label="Monto"
              type="number"
              cols="6"
              :rules="[mixReglas.requerido]"
            >
            </text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgergarFianza"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixFianzaContrato from './mixFianzaContrato';
import TextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'RegistrarNuevaFianza',
  mixins: [mixFianzaContrato],
  props: {
    contrato: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextField,
    DatePicker,
    CustomButton,
    CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipos: [
        { id: 1, nombre: 'Cumplimiento' },
        { id: 2, nombre: 'Anticipo' },
        { id: 3, nombre: 'Vicios ocultos' },
      ],
      fianza: {
        idContrato: this.contrato.id,
        tipo: '',
        numero: '',
        fecha: null,
        nombreAfianzadora: '',
        monto: 0,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevaFianza.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
